<script setup lang="ts">
defineProps<{
  value?: string | Date
  precise?: boolean
}>()

const i18n = useI18n()

function timeAgo(date: string | Date) {
  const now = new Date()
  const then = parseDate(date)
  const timeDifferenceInMilliseconds = now.getTime() - then.getTime()

  const seconds = Math.floor(timeDifferenceInMilliseconds / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)
  const weeks = Math.floor(days / 7)
  const months = Math.floor(days / 30)
  const years = Math.floor(days / 365)

  if (years > 0) {
    return i18n.t('date.years', years)
  } else if (months > 0) {
    return i18n.t('date.months', months)
  } else if (weeks > 0) {
    return i18n.t('date.weeks', weeks)
  } else if (days > 0) {
    return i18n.t('date.days', days)
  } else if (hours > 0) {
    return i18n.t('date.hours', hours)
  } else if (minutes > 0) {
    return i18n.t('date.minutes', minutes)
  } else {
    return i18n.t('date.seconds')
  }
}

function preciseDate(date: string | Date) {
  // parse the date
  const now = parseDate(date)

  // return the date in the correct format
  return now.toLocaleString(i18n.t('language.locale'), {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
</script>

<template>
  {{ value ? (precise ? preciseDate(value) : timeAgo(value)) : '' }}
</template>
